import React from "react"
import ConvenienceImg from "./ConvenienceImg"

const Convenience = () => {
  return (
    <div className="row justify-content-around align-items-center py-5">
      <div className="col-lg-5 mobile-padding">
        <ConvenienceImg />
      </div>
      <div className="col-lg-4 mobile-padding">
        <h3 className="text-tang">Convenience</h3>
        <p>
          Self-directed IRAs allow investors to invest in offerings on a
          tax-advantage basis. Prime Trust is the custodian, making it easy to
          not only set up accounts, but also direct your investment into an
          opportunity that helps feed, clothe and fuel the world.
        </p>
      </div>
    </div>
  )
}

export default Convenience
